import { noop } from '@tanstack/react-query';
import { changeAssessmentListQuery } from '@/features/supplements/queries';
import { entityDocumentsQuery } from '@/features/documents/queries';
import { Main, MainPending } from '@/ui/components/main';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useNoDocumentsToast } from '@/features/documents/helpers';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId',
)({
  staticData: { chatSurface: 'contractual_supplement' },
  component: RouteComponent,
  loader: async (opts) => {
    opts.context.queryClient
      .query(entityDocumentsQuery(opts.params.supplementId, 'supplement'))
      .catch(noop);
    await opts.context.queryClient.query({
      ...changeAssessmentListQuery(opts.params.supplementId, opts.params.workspaceId),
      staleTime: 'static',
    });
  },
  pendingComponent: MainPending,
});

function RouteComponent() {
  const { projectId, workspaceId, supplementId } = Route.useParams();
  const navigate = useNavigate();

  useNoDocumentsToast({
    resourceId: supplementId,
    documentType: 'supplement',
    onGoToFiles: () =>
      navigate({
        to: '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files',
        params: { projectId, workspaceId, supplementId },
      }),
  });

  return (
    <Main>
      <Outlet />
    </Main>
  );
}
